import { render, staticRenderFns } from "./NoResultsPlaceholder.vue?vue&type=template&id=0521e575&scoped=true&"
import script from "./NoResultsPlaceholder.vue?vue&type=script&lang=js&"
export * from "./NoResultsPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./NoResultsPlaceholder.vue?vue&type=style&index=0&id=0521e575&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0521e575",
  null
  
)

export default component.exports